export default "__VITE_ASSET__62g$osaY__"